import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { percentageSignFilter } from "app/filters/ngFilters";
import { TrafficShareTooltip } from "pro-features/components/tooltips/src/TrafficShareTooltip/TrafficShareTooltip";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { ProgressBar } from "../../ProgressBar/ProgressBar";

import { NO_DATA_MESSAGE } from "./IntentCell";

const ProgressBarContainer = styled(CenteredFlexRow)<{ shouldAddRightSpace: boolean }>`
    width: 100%;
    padding-right: ${({ shouldAddRightSpace = false }) => (shouldAddRightSpace ? 12 : 0)}px;
`;
const AlignRight = styled.div`
    text-align: right;
    padding-right: 8px;
`;
const tooltipData = (value: number, isSourceType: boolean) => [
    {
        color: colorsPalettes.carbon[0],
        backgroundColor: colorsPalettes.blue[500],
        width: 0.22,
        text: percentageSignFilter()(value, 2),
        name: isSourceType ? translate("share.tooltip.organic") : translate("share.tooltip.desktop"),
    },
    {
        color: colorsPalettes.carbon[0],
        backgroundColor: colorsPalettes.sky[300],
        width: 0.22,
        text: percentageSignFilter()(1 - value, 2),
        name: isSourceType ? translate("share.tooltip.paid") : translate("share.tooltip.mobile"),
    },
];

export const CompareBarCell = ({
    value,
    shouldAddRightSpace = false,
    isSourceType = false,
    displayNoData = false,
}: {
    value: number;
    shouldAddRightSpace: boolean;
    isSourceType?: boolean;
    displayNoData?: boolean;
}) => {
    return displayNoData ? (
        <AlignRight>{NO_DATA_MESSAGE}</AlignRight>
    ) : (
        <TrafficShareTooltip trafficShareProps={tooltipData(value, isSourceType)}>
            <ProgressBarContainer shouldAddRightSpace={shouldAddRightSpace}>
                <ProgressBar
                    width={value * 100}
                    className="u-full-width"
                    isCompare={true}
                    height={8}
                />
            </ProgressBarContainer>
        </TrafficShareTooltip>
    );
};
CompareBarCell.displayName = "CompareBarCell";
